(function () {
  'use strict';
  var DRAG = 8, SETTLE = 110, P = { capture: true, passive: true };

  // Per-gallery cache. Nothing here is re-queried or re-measured during a swipe.
  function C(g) {
    var c = g._c;
    if (!c) {
      c = g._c = {
        t: g.querySelector('[data-gg-track]'),
        dots: g.querySelectorAll('[data-gg-dot]'),
        prev: g.querySelector('[data-gg-prev]'),
        next: g.querySelector('[data-gg-next]'),
        n: g.querySelectorAll('[data-gg-slide]').length,
        w: 0, i: -1, warm: false
      };
    }
    if (!c.w && c.t) c.w = c.t.clientWidth || 0;   // measured once, not per frame
    return c;
  }

  // Only touches the DOM when the visible image actually changes.
  function paint(g, force) {
    var c = C(g); if (!c.t || !c.w) return;
    var i = Math.round(c.t.scrollLeft / c.w);
    if (i === c.i && !force) return;               // <- the swipe fast-path: zero work
    c.i = i;
    for (var d = 0; d < c.dots.length; d++) c.dots[d].classList.toggle('is-active', d === i);
    if (c.prev) c.prev.disabled = i <= 0;
    if (c.next) c.next.disabled = i >= c.n - 1;
  }

  // Lazy images stall the first swipe. Promote them the moment the user
  // touches the gallery, so the next image is already decoded.
  function warm(g) {
    var c = C(g); if (c.warm) return; c.warm = true;
    var im = g.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < im.length; i++) { im[i].loading = 'eager'; im[i].decoding = 'async'; }
  }

  function goTo(g, i, smooth) {
    var c = C(g); if (!c.t || !c.w) return;
    i = Math.max(0, Math.min(c.n - 1, i));
    var target = i * c.w;
    if (Math.abs(c.t.scrollLeft - target) < 1) return;
    try { c.t.scrollTo({ left: target, behavior: smooth === false ? 'auto' : 'smooth' }); }
    catch (e) { c.t.scrollLeft = target; }
  }

  function settle(g) {
    var c = C(g); if (!c.t || !c.w) return;
    var off = c.t.scrollLeft % c.w;
    if (off > 4 && off < c.w - 4) goTo(g, Math.round(c.t.scrollLeft / c.w), true);
    paint(g);
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.hasAttribute || !t.hasAttribute('data-gg-track')) return;
    var g = t.parentNode; if (!g || !g.hasAttribute('data-gg')) return;
    if (g._raf) return;                            // coalesce to one frame
    g._raf = requestAnimationFrame(function () { g._raf = 0; paint(g); });
    if (g._lock) return;
    clearTimeout(g._st);
    g._st = setTimeout(function () { settle(g); }, SETTLE);
  }, P);

  document.addEventListener('scrollend', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || !t.hasAttribute || !t.hasAttribute('data-gg-track')) return;
    var g = t.parentNode;
    if (g && g.hasAttribute('data-gg') && !g._lock) { clearTimeout(g._st); settle(g); }
  }, P);

  var sx = 0, sy = 0, down = false, swiped = 0;
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('[data-gg-track]'); if (!t) return;
    var g = t.parentNode; if (g && g.hasAttribute('data-gg')) warm(g);
    sx = e.clientX; sy = e.clientY; down = true;
  }, P);
  document.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = Math.abs(e.clientX - sx);
    if (dx > DRAG && dx > Math.abs(e.clientY - sy)) swiped = Date.now();
  }, P);
  function up() { down = false; }
  document.addEventListener('pointerup', up, P);
  document.addEventListener('pointercancel', up, P);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-gg-slide]') && Date.now() - swiped < 320) {
      e.preventDefault(); e.stopPropagation(); return;
    }
    var el = e.target.closest('[data-gg-prev],[data-gg-next],[data-gg-dot]');
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    var g = el.closest('[data-gg]'); if (!g) return;
    warm(g);
    g._lock = true; setTimeout(function () { g._lock = false; }, 450);
    var c = C(g);
    if (el.hasAttribute('data-gg-dot')) goTo(g, parseInt(el.getAttribute('data-gg-index'), 10) || 0);
    else goTo(g, Math.round(c.t.scrollLeft / (c.w || 1)) + (el.hasAttribute('data-gg-next') ? 1 : -1));
  }, true);

  function initAll() {
    var l = document.querySelectorAll('[data-gg]');
    for (var i = 0; i < l.length; i++) paint(l[i], true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('resize', function () {
    clearTimeout(window._ggRz);
    window._ggRz = setTimeout(function () {
      var l = document.querySelectorAll('[data-gg]');
      for (var i = 0; i < l.length; i++) {
        var g = l[i], c = C(g);
        if (c.t) { var was = c.w ? Math.round(c.t.scrollLeft / c.w) : 0; c.w = c.t.clientWidth || 0; goTo(g, was, false); }
        paint(g, true);
      }
    }, 200);
  }, { passive: true });
})();
